import { useMe } from '@/auth/useMe';
import { useSettings } from './SettingsContext';
import type { ModuleKey } from './modules';

/**
 * האם מודול פעיל. מודול כבוי מוסתר לגמרי: תפריט, מסכים, כרטיסים והתראות.
 *
 * כשיש עובד מחובר, המקור הוא me(), שמחזיר את המודולים באותה קריאה שבה
 * מגיעות ההרשאות. זה מונע מצב שבו המטמון של app_settings עדיין מחזיק
 * את התשובה האנונימית, שבה אין modules בכלל.
 *
 * הבדיקה בממשק היא נוחות; ההגנה האמיתית היא module_enabled ב RLS ובפונקציות.
 */
export function useModules(): Record<ModuleKey, boolean> {
  const { me } = useMe();
  const { modules } = useSettings();
  return me?.modules ?? modules;
}

export function useModule(key: ModuleKey): boolean {
  return useModules()[key] === true;
}
